import { render } from "./PendingCredits.vue?vue&type=template&id=785dd34e&scoped=true&ts=true"
import script from "./PendingCredits.vue?vue&type=script&lang=ts"
export * from "./PendingCredits.vue?vue&type=script&lang=ts"

import "./PendingCredits.vue?vue&type=style&index=0&id=785dd34e&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785dd34e"]])

export default __exports__